/* ADSCALAR — Size Guide + Find My Size drawers. Ports the Hydrogen logic:
   per-product HL_size_chart table (inch/cm + garment toggle + row-select) and
   the bust-grading size recommender. Talks to the PDP via window.ekPDP. */
(function () {
  var root = document.querySelector('.asc-pdp');
  if (!root) return;

  var sections = [];
  try { sections = JSON.parse(root.querySelector('[data-asc-sizechart]').textContent || '[]'); } catch (e) {}
  if (!sections.length) {
    sections = [{ title: 'Kurta', cols: ['Bust', 'Waist', 'Hip', 'Shoulder', 'Length'],
      rows: [{ size: 'XS', vals: [32,26,35,13.5,44] }, { size: 'S', vals: [34,28,37,14,45] },
        { size: 'M', vals: [36,30,39,14.5,45.5] }, { size: 'L', vals: [38,32,41,15,46] },
        { size: 'XL', vals: [40,34,43,15.5,46.5] }, { size: 'XXL', vals: [42,36,45,16,47] }] }];
  }

  var scrim = root.querySelector('[data-asc-sg-scrim]');
  var guide = root.querySelector('[data-asc-sg-guide]');
  var find = root.querySelector('[data-asc-sg-find]');
  var openPanel = null;
  var lastTrigger = null;

  var FOCUSABLE = 'input, button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';
  function focusables(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function open(panel) {
    openPanel = panel;
    // Stash the trigger so focus returns to it on close (mirrors Hydrogen).
    lastTrigger = document.activeElement;
    scrim.classList.add('open'); panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-locked');
    // Autofocus the first focusable element inside the panel (~60ms, post-transition start).
    setTimeout(function () {
      if (openPanel !== panel) return;
      var f = focusables(panel)[0];
      if (f) f.focus();
    }, 60);
  }
  function closeAll() {
    scrim.classList.remove('open');
    [guide, find].forEach(function (p) { if (p) { p.classList.remove('open'); p.setAttribute('aria-hidden', 'true'); } });
    document.body.classList.remove('scroll-locked');
    openPanel = null;
    // Return focus to the element that opened the drawer.
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }
  scrim.addEventListener('click', closeAll);
  root.querySelectorAll('[data-asc-sg-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) { closeAll(); return; }
    // Focus trap — keep Tab within the open panel.
    if (e.key === 'Tab' && openPanel) {
      var list = focusables(openPanel);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  var openGuideBtn = root.querySelector('[data-asc-open-sizeguide]');
  var openFindBtn = root.querySelector('[data-asc-open-findsize]');
  if (openGuideBtn) openGuideBtn.addEventListener('click', function () { buildGuide(); open(guide); });
  if (openFindBtn) openFindBtn.addEventListener('click', function () { resetFind(); open(find); });

  // ───────────────────────── SIZE GUIDE ─────────────────────────
  var unit = 'IN';
  var activeSection = 0;
  function fmt(n) {
    if (n === null || n === undefined || isNaN(n)) return '—';
    return unit === 'IN' ? n + '"' : Math.round(n * 2.54) + ' cm';
  }
  function buildGuide() {
    // garment toggle
    var gWrap = root.querySelector('[data-asc-garment]');
    if (sections.length > 1) {
      gWrap.hidden = false;
      gWrap.innerHTML = sections.map(function (s, i) {
        var on = i === activeSection;
        return '<button type="button" data-gi="' + i + '" class="' + (on ? 'on' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + (s.title || ('Table ' + (i + 1))) + '</button>';
      }).join('');
      gWrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { activeSection = +b.getAttribute('data-gi'); buildGuide(); });
      });
    } else { gWrap.hidden = true; gWrap.innerHTML = ''; }

    var s = sections[activeSection] || sections[0];
    var selectable = (window.ekPDP ? window.ekPDP.selectableSizes() : []).map(function (x) { return x.toUpperCase(); });
    var chosen = (window.ekPDP ? window.ekPDP.selectedSize() : '').toUpperCase();

    // Grid-driven table (mirrors Hydrogen): a leading checkbox column picks the
    // size; the chosen row is tinted. Columns are fixed-width and scroll
    // horizontally so long headers never crush.
    var nCols = s.cols.length;
    var gridCols = '24px 46px repeat(' + nCols + ', 64px)';
    var html = '<div class="asc-sg-tbl">';
    // header
    html += '<div class="asc-sg-row asc-sg-rowhead" style="grid-template-columns:' + gridCols + '"><span aria-hidden="true"></span><span class="hd">Size</span>';
    s.cols.forEach(function (c) { html += '<span class="hd">' + c + '</span>'; });
    html += '</div>';
    s.rows.forEach(function (r) {
      var up = String(r.size).toUpperCase();
      var pickable = selectable.indexOf(up) > -1;
      var isSel = chosen && up === chosen;
      var ds = String(r.size).replace(/"/g, '&quot;');
      var cls = 'asc-sg-row' + (isSel ? ' sel' : '') + (pickable ? ' pickable' : '');
      var tag = pickable ? 'label' : 'div';
      html += '<' + tag + ' class="' + cls + '" data-size="' + ds + '" style="grid-template-columns:' + gridCols + '">';
      html += '<input type="checkbox" class="asc-sg-chk"' + (isSel ? ' checked' : '') + (pickable ? '' : ' disabled') + ' aria-label="Select size ' + ds + '">';
      html += '<span>' + r.size + '</span>';
      r.vals.forEach(function (v) { html += '<span>' + fmt(v) + '</span>'; });
      html += '</' + tag + '>';
    });
    html += '</div>';
    var tableEl = root.querySelector('[data-asc-sg-table]');
    tableEl.innerHTML = html;
    tableEl.querySelectorAll('.asc-sg-row.pickable .asc-sg-chk').forEach(function (chk) {
      chk.addEventListener('change', function () {
        var row = chk.closest('.asc-sg-row');
        if (window.ekPDP && row) window.ekPDP.selectSize(row.getAttribute('data-size'));
        buildGuide();
      });
    });
  }
  root.querySelectorAll('[data-asc-unit] button').forEach(function (b) {
    b.addEventListener('click', function () {
      unit = b.getAttribute('data-unit');
      root.querySelectorAll('[data-asc-unit] button').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('on', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      buildGuide();
    });
  });

  // ───────────────────────── FIND MY SIZE ─────────────────────────
  var LADDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  function bustChart() {
    for (var k = 0; k < sections.length; k++) {
      var s = sections[k];
      var ci = -1;
      for (var c = 0; c < s.cols.length; c++) { if (/chest|bust/i.test(s.cols[c])) { ci = c; break; } }
      if (ci < 0) continue;
      var g = s.rows.map(function (r) { return { size: String(r.size).toUpperCase(), bust: r.vals[ci] }; })
        .filter(function (r) { return r.size && typeof r.bust === 'number'; })
        .sort(function (a, b) { return a.bust - b.bust; });
      if (g.length) return g;
    }
    return [{ size: 'XS', bust: 32 }, { size: 'S', bust: 34 }, { size: 'M', bust: 36 },
      { size: 'L', bust: 38 }, { size: 'XL', bust: 40 }, { size: 'XXL', bust: 42 }];
  }
  function fmtHeight(inches) { return Math.floor(inches / 12) + "'" + (inches % 12) + '"'; }

  function recommend(form, chart) {
    if (!form.height || !form.weight || !chart.length) return null;
    var heightIn = +form.height, weightKg = +form.weight;
    var heightCm = heightIn * 2.54;
    var bmi = weightKg / Math.pow(heightCm / 100, 2);
    var buildAdj = form.build === 'curvy' ? 1.5 : form.build === 'athletic' ? 0.5 : form.build === 'petite' ? -1 : 0;
    var heightAdj = (heightIn - 63) * 0.12;
    var bodyBust = 31.5 + 0.3 * (weightKg - 50) + buildAdj + heightAdj;
    var ease = form.fit === 'fitted' ? 1 : form.fit === 'relaxed' ? 3.5 : 2;
    var target = bodyBust + ease;
    var idx = chart.findIndex(function (r) { return r.bust >= target; });
    var overSize = idx < 0;
    if (idx < 0) idx = chart.length - 1;
    var row = chart[idx], size = row.size, bust = row.bust;
    var alt = chart[Math.min(chart.length - 1, idx + 1)].size;
    var prevBust = idx > 0 ? chart[idx - 1].bust : bust - 2;
    var nearLower = idx > 0 && (target - prevBust) < 0.6;
    var confidence = (overSize || nearLower || bmi < 16 || bmi > 33) ? 'Medium' : 'High';
    var room = Math.max(0, Math.round(bust - bodyBust));
    var fitWord = form.fit === 'fitted' ? 'a close' : form.fit === 'relaxed' ? 'a relaxed' : 'a true';
    var fitNote = 'Size ' + size + ' measures ' + bust + '" at the bust — about ' + room + '" of room over your frame for ' + fitWord + ' fit.';
    var lengthNote;
    if (heightIn < 61) lengthNote = 'At ' + fmtHeight(heightIn) + ', the length may run long — an easy hem sets it ankle-length.';
    else if (heightIn > 68) lengthNote = 'At ' + fmtHeight(heightIn) + ', our regular length sits mid-calf; size ' + size + ' keeps the proportions right.';
    else lengthNote = 'At ' + fmtHeight(heightIn) + ', our regular length falls as designed — no alteration needed.';
    var buildNote = form.build === 'curvy' ? 'Cut allows comfortable room through the bust & hip.'
      : form.build === 'athletic' ? 'Roomy through the shoulder; the cut allows movement.'
      : form.build === 'petite' ? 'Petite frame — the shorter rise suits you well.' : '';
    return { size: size, alt: alt, confidence: confidence, fitNote: fitNote, lengthNote: lengthNote, buildNote: buildNote };
  }
  function snapToAvailable(size, available) {
    var set = (available || []).map(function (s) { return s.toUpperCase(); });
    if (!set.length || set.indexOf(size) > -1) return size;
    var target = LADDER.indexOf(size);
    if (target < 0) return set[0];
    var best = null, bestDist = Infinity;
    set.forEach(function (s) { var i = LADDER.indexOf(s); if (i < 0) return; var d = Math.abs(i - target); if (d < bestDist) { bestDist = d; best = s; } });
    return best || size;
  }

  var form = { height: '', weight: '', age: '', build: '', fit: 'true' };
  // height select
  var hSel = root.querySelector('[data-asc-height]');
  if (hSel) {
    for (var i = 58; i <= 74; i++) { var o = document.createElement('option'); o.value = i; o.textContent = fmtHeight(i); hSel.appendChild(o); }
    // Dim the 'Select' prompt to ink-light until a real value is chosen.
    hSel.classList.toggle('placeholder', !hSel.value);
  }
  var wInput = root.querySelector('[data-asc-weight]');
  var submitBtn = root.querySelector('[data-asc-find-submit]');
  function syncSubmit() { if (submitBtn) submitBtn.disabled = !(form.height && form.weight && form.build); }
  if (hSel) hSel.addEventListener('change', function () { form.height = this.value; this.classList.toggle('placeholder', !this.value); syncSubmit(); });
  if (wInput) wInput.addEventListener('input', function () { form.weight = this.value; syncSubmit(); });
  function wirePills(group, key) {
    root.querySelectorAll('[data-asc-' + group + '] button').forEach(function (b) {
      b.addEventListener('click', function () {
        form[key] = b.getAttribute('data-v');
        root.querySelectorAll('[data-asc-' + group + '] button').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        syncSubmit();
      });
    });
  }
  wirePills('age', 'age');
  wirePills('build', 'build');
  wirePills('fit', 'fit');

  var formWrap = root.querySelector('[data-asc-find-form]');
  var resultWrap = root.querySelector('[data-asc-find-result]');
  var eyebrow = root.querySelector('[data-asc-find-eyebrow]');

  function resetFind() {
    if (formWrap) formWrap.hidden = false;
    if (resultWrap) { resultWrap.hidden = true; resultWrap.innerHTML = ''; }
    if (eyebrow) eyebrow.textContent = 'A quick fit check';
  }
  if (submitBtn) submitBtn.addEventListener('click', function () {
    var rec = recommend(form, bustChart());
    if (!rec) return;
    var avail = window.ekPDP ? window.ekPDP.selectableSizes() : [];
    var pick = snapToAvailable(rec.size, avail);
    var snapped = pick !== rec.size;
    var notes = [rec.fitNote, rec.lengthNote, rec.buildNote].filter(Boolean);
    var check = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
    var html = '<div class="asc-find-result"><div class="asc-find-hero"><p class="lead">We recommend</p>' +
      '<div class="asc-find-circle">' + rec.size + '</div>' +
      '<div class="asc-find-conf ' + (rec.confidence === 'High' ? 'high' : 'med') + '"><span class="d"></span>' + rec.confidence + ' confidence</div></div>' +
      '<div class="asc-find-notes">' + notes.map(function (n) { return '<div class="n">' + check + '<span>' + n + '</span></div>'; }).join('') + '</div>';
    if (rec.alt !== rec.size) html += '<p class="asc-find-between">Between sizes or prefer extra room? Size <b>' + rec.alt + '</b> also works for a relaxed drape.</p>';
    if (snapped) html += '<p class="asc-sg-note">Size <b>' + rec.size + "</b> isn't available in this style — we'll select <b>" + pick + '</b>, the closest in stock.</p>';
    html += '<button class="asc-find-apply" type="button" data-asc-find-apply>Select size ' + pick + ' →</button>' +
      '<button class="asc-find-recalc" type="button" data-asc-find-recalc>Recalculate</button></div>';
    resultWrap.innerHTML = html;
    formWrap.hidden = true; resultWrap.hidden = false;
    if (eyebrow) eyebrow.textContent = 'Your recommended size';
    resultWrap.querySelector('[data-asc-find-apply]').addEventListener('click', function () {
      if (window.ekPDP) window.ekPDP.selectSize(pick);
      closeAll();
    });
    resultWrap.querySelector('[data-asc-find-recalc]').addEventListener('click', resetFind);
  });
})();
